import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import Login from './Login';
import { ShieldAlert, RefreshCw, WifiOff } from 'lucide-react';
// Also styles the error-boundary fallback in App, so import it here, not only via Login
import './Auth.css';

const ProtectedRoute = ({ children, requiredApp = 'dispatch' }) => {
  const { user, loading, hasAppAccess, appsError, retryAppAccess } = useAuth();

  if (loading) {
    return (
      <div className="loading-page">
        <div className="loading-content" role="status">
          <div className="loading-spinner" aria-hidden="true"></div>
          <p>Loading...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Login />;
  }

  // Access lookup failed (e.g. network) - offer a retry instead of a false Access Denied
  if (appsError) {
    return (
      <div className="access-denied-page">
        <div className="access-denied-container" role="alert">
          <div className="access-denied-icon" aria-hidden="true">
            <WifiOff size={32} />
          </div>
          <h2>Couldn't Check Access</h2>
          <p>{appsError}</p>
          <button
            className="access-denied-button"
            onClick={retryAppAccess}
          >
            <RefreshCw size={16} aria-hidden="true" />
            Retry
          </button>
        </div>
      </div>
    );
  }

  if (!hasAppAccess(requiredApp)) {
    return (
      <div className="access-denied-page">
        <div className="access-denied-container" role="alert">
          <div className="access-denied-icon" aria-hidden="true">
            <ShieldAlert size={32} />
          </div>
          <h2>Access Denied</h2>
          <p>You do not have access to the {requiredApp} application.</p>
          <p className="access-denied-hint">
            Please contact your administrator to request access.
          </p>
          <button
            className="access-denied-button"
            onClick={() => window.location.reload()}
          >
            <RefreshCw size={16} aria-hidden="true" />
            Refresh
          </button>
        </div>
      </div>
    );
  }

  return children;
};

export default ProtectedRoute;
